import { useEffect, useState } from "react";
import {
  BUTTON_LABEL,
  LABELS,
  DATE_FORMAT,
  MESSAGE,
  toastSuccess,
} from "../../../shared/constants";
import { useNavigate, useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import { usePublicOrderGetQuery } from "../../../Features/order/order-slice";
import moment from "moment";
import SimpleButton from "../../../shared/components/Button/Button";
import Loader from "../../../shared/components/Loader";
import TextBox from "../../../shared/components/TextBox";
import TextArea from "../../../shared/components/TextArea";

import {
  OrderStatus,
  ORDER_STATUS,
  USER_TYPE,
} from "../../../shared/constants/resource";
import { timeDifference } from "../../../shared/helperFunc/timeDifference";

const OrderInvoicePdf = (props: any) => {
  const { } = props;
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [orderDetailData, setOrderDetailData]: any = useState();
  const [orderItemIndex, setOrderItemIndex]: any = useState();

  const {
    data: getOrderData,
    isLoading: getOrderLoading,
    isSuccess: getOrderSuccess,
    isError: getOrderError,
  } = usePublicOrderGetQuery(orderId || skipToken, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (orderId && getOrderSuccess) {
      setOrderDetailData(getOrderData.item);
      toastSuccess(getOrderData?.message);
    }
  }, [orderId, getOrderData, getOrderSuccess, orderItemIndex]);

  const handlePrint = () => {
    window.print();
  };

  const toggleShowOrderItem = (index: any) => {
    setOrderItemIndex(index);
  };

  const toggleHideorderItem = () => {
    setOrderItemIndex(undefined);
  };

  const orderStatusBlock = (type: any) => {
    const orderStatus = ORDER_STATUS.find((ele: any) => {
      return ele._id === type;
    });
    return orderStatus ? (
      <p className={`mb-0 ${orderStatus.class} col-md-6`}>
        {LABELS[orderStatus.name]}
      </p>
    ) : (
      "-"
    );
  };

  const measurementStandardBlock = (item: any) => {
    return (
      <div className="value">
        <label htmlFor="">{item?.title}</label>
        <span className="label-box">{item?.value}</span>
      </div>
    );
  };

  const measurementCustomBlock = (title: any, value: any) => {
    if (value) {
      return (
        <div className="col-md-4">
          <div className="slug-custom-dropdown mb-3 open">
            <div className="toggle d-flex align-items-center w-100 justify-content-between">
              <span>{title}</span>
            </div>

            <div className="custom-dropdown-menu">
              <div className="item-card">
                <div className="item-body">
                  <div className="populate-values">
                    <span>{value}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      {getOrderLoading ? (
        <Loader />
      ) : getOrderError || !orderDetailData || !orderId ? (
        <div className="page-full">
          <div className="feedback-msg error mt-5">
            <i>!</i>
          </div>
          <div className="text-center">
            <h1>{LABELS.OOPS_TEXT}!</h1>
            <p className="mt-3">{MESSAGE.ORDER_NOT_FOUND_MESSAGE}</p>
          </div>
        </div>
      ) : (
        <>
          <div className="order-invoice-pdf">
            <div className="container-fluid">
              <h5 className="col-6 my-2 mx-auto print-col-12">
                {orderDetailData.documentNo}
              </h5>
              <div className="row">
                <div className="col-6 mx-auto print-col-12">
                  <div className="card custom-card card-full mt-3 has-radius has-input">
                    <div className="card-body">
                      <div className="card section-card mb-3">
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col-md-4">
                              <div className="form-group row mb-3">
                                <div className="col-md-6">
                                  <strong>{LABELS.ORDER_NO_TEXT} - </strong>
                                </div>
                                <div className="col-md-6">
                                  {orderDetailData.documentNo
                                    ? orderDetailData.documentNo
                                    : " -"}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row align-items-center">
                            <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.ORDER_DATE_TEXT} -
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <p className="mb-0 text-muted">
                                    {moment(orderDetailData.createdAt).format(
                                      DATE_FORMAT.STANDARD
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                            {/* <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.STORE_DELIVERY_DATE_TEXT} -
                                  </label>
                                </div>
                                <p className="mb-0 text-muted col-md-6">
                                  {moment(orderDetailData.deliveryDate).format(
                                    DATE_FORMAT.STANDARD
                                  )}
                                </p>
                              </div>
                            </div> */}
                            <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.CUSTOMER_NAME_TEXT}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <p className="mb-0 text-muted">
                                    {orderDetailData.firstName +
                                      " " +
                                      orderDetailData.middleName +
                                      " " +
                                      orderDetailData.lastName}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row align-items-center">
                            {/* <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.DESTINATION_SITE_TEXT} -
                                  </label>
                                </div>
                                <p className="mb-0 text-muted col-md-6">
                                  {orderDetailData.destinationSiteCode
                                    ? orderDetailData.destinationSiteCode
                                    : "-"}
                                </p>
                              </div>
                            </div> */}
                            {/* <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.SHORT_CODE_TEXT}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <p className="mb-0 text-muted">
                                    {orderDetailData?.store.shortCode}
                                  </p>
                                </div>
                              </div>
                            </div> */}
                            <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.PHONE_TEXT}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <p className="mb-0 text-muted">
                                    {orderDetailData.customerMobile}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.ADDRESS_TEXT}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <p className="mb-0 text-muted">
                                    {orderDetailData.address
                                      ? orderDetailData.address
                                      : "-"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row align-items-center">
                            {/* <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.SO_NO_TEXT} -
                                  </label>
                                </div>
                                <p className="mb-0 text-muted col-md-6">
                                  {orderDetailData.ordCode
                                    ? orderDetailData.ordCode
                                    : "-"}
                                </p>
                              </div>
                            </div> */}
                            {/* <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.CHECKER_ID_TEXT} -
                                  </label>
                                </div>
                                <p className="mb-0 text-muted col-md-6">
                                  {orderDetailData.checkerId
                                    ? orderDetailData.checkerId
                                    : "-"}
                                </p>
                              </div>
                            </div> */}
                          </div>
                          <div className="row align-items-center">
                            <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.STATUS_TEXT} -
                                  </label>
                                </div>
                                {orderStatusBlock(orderDetailData.status)}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.CREATED_BY_TEXT} -
                                  </label>
                                </div>
                                <p className="mb-0 text-muted col-md-6">
                                  {orderDetailData.store?.name
                                    ? orderDetailData.store?.name
                                    : "-"}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.ADVANCE_AMOUNT_TEXT}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <p className="mb-0 text-muted">
                                    {orderDetailData.advancePay?.amount
                                      ? orderDetailData.advancePay?.amount
                                      : "-"}
                                  </p>
                                </div>
                              </div>
                            </div>
                            {/* <div className="col-md-4">
                              <div className="form-group row">
                                <div className="col-md-6">
                                  <label
                                    htmlFor=""
                                    className="text-black font-weight-600"
                                  >
                                    {LABELS.ADVANCE_REMARKS_TEXT}
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <p className="mb-0 text-muted">
                                    {orderDetailData.advancePay?.remarks
                                      ? orderDetailData.advancePay?.remarks
                                      : "-"}
                                  </p>
                                </div>
                              </div>
                            </div> */}
                            {/* {orderDetailData?.advancePay?.paymentAt && (
                              <div className="col-md-4">
                                <div className="form-group row">
                                  <div className="col-md-6">
                                    <label
                                      htmlFor=""
                                      className="text-black font-weight-600"
                                    >
                                      {LABELS.APPROVAL_TAT_TEXT}
                                    </label>
                                  </div>
                                  <div className="col-md-6">
                                    <p className="mb-0 text-muted">
                                      {timeDifference(
                                        orderDetailData?.createdAt,
                                        orderDetailData?.advancePay?.paymentAt
                                      )}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )} */}
                          </div>
                        </div>
                      </div>

                      {orderDetailData.status === OrderStatus.CANCELED && (
                        <>
                          <h6 className="my-3 section-title">
                            {LABELS.CANCEL_DETAILS_TEXT}
                          </h6>
                          <div className="card section-card mb-3">
                            <div className="card-body">
                              <div className="row">
                                <div className="col-md-3 col-12">
                                  <div className="form-group mb-0">
                                    <label
                                      htmlFor=""
                                      className="text-black font-weight-600"
                                    >
                                      {LABELS.REMARKS_TEXT}
                                    </label>
                                    <p className="mb-0 text-muted">
                                      {orderDetailData.cancel?.remarks || "-"}
                                    </p>
                                  </div>
                                </div>
                                {/* {orderDetailData.cancel?.code && (
                                  <div className="col-md-3 col-12">
                                    <div className="form-group mb-0">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.CANCEL_CODE_TEXT}
                                      </label>
                                      <p className="mb-0 text-muted">
                                        {orderDetailData.cancel?.code}
                                      </p>
                                    </div>
                                  </div>
                                )}
                                {orderDetailData.cancel?.no && (
                                  <div className="col-md-3 col-12">
                                    <div className="form-group mb-0">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.CANCEL_NO_TEXT}
                                      </label>
                                      <p className="mb-0 text-muted">
                                        {orderDetailData.cancel?.no}
                                      </p>
                                    </div>
                                  </div>
                                )} */}
                                {orderDetailData?.cancel?.canceledAt && (
                                  <div className="col-md-3 col-12">
                                    <div className="form-group mb-0">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.CANCEL_TAT_TEXT}
                                      </label>
                                      <p className="mb-0 text-muted">
                                        {timeDifference(
                                          orderDetailData?.createdAt,
                                          orderDetailData?.cancel?.canceledAt
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                )}
                                {/* <div className="col-md-3 col-12">
                                  <div className="form-group mb-0">
                                    <label
                                      htmlFor=""
                                      className="text-black font-weight-600"
                                    >
                                      {LABELS.CANCELLED_BY_TEXT}
                                    </label>
                                    <p className="mb-0 text-muted">
                                      {`${orderDetailData.canceledBy?.name} (${
                                        USER_TYPE[
                                          orderDetailData.canceledBy.type
                                        ]
                                      })`}
                                    </p>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {/* <h6 className="my-3 section-title">
                        {LABELS.ITEM_DETAILS_TEXT}
                      </h6>
                      {orderDetailData.items.map((el: any, index: any) => {
                        return (
                          <div className="card section-card mb-3 collapsible-card">
                            <div
                              className="card-header d-flex align-items-center justify-content-between"
                              onClick={
                                orderItemIndex === index
                                  ? () => toggleHideorderItem()
                                  : () => toggleShowOrderItem(index)
                              }
                            >
                              <h6 className="section-title card-title mb-0">
                                <span>{el.itemCode ? el.itemCode : " -"}</span>
                                {el.isCustom && (
                                  <>
                                    &nbsp;-&nbsp;
                                    <span className="ribbon-label">
                                      {LABELS.CUSTOM_TEXT}
                                    </span>
                                  </>
                                )}
                              </h6>
                              <div className="chevron-circle">
                                <i
                                  className={`${
                                    orderItemIndex === index
                                      ? icons.ICON_CHEVRON_UP
                                      : icons.ICON_CHEVRON_DOWN
                                  } cursor-pointer`}
                                ></i>
                              </div>
                            </div>
                            <div
                              className={`card-body ${
                                orderItemIndex === index && "show"
                              }`}
                            >
                              <div className="row align-items-center">
                                <div className="col-md-4">
                                  <div className="form-group row mb-3">
                                    <div className="col-md-6">
                                      <strong>{LABELS.I_CODE_TEXT} - </strong>
                                    </div>
                                    <div className="col-md-6">
                                      {el.itemCode ? el.itemCode : " -"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row align-items-center">
                                <div className="col-md-4">
                                  <div className="form-group row">
                                    <div className="col-md-6">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.DESIGN_NO_TEXT} -
                                      </label>
                                    </div>
                                    <div className="col-md-6">
                                      {el?.designNo ? el?.designNo : "-"}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group row">
                                    <div className="col-md-6">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.PRICE_TEXT} -
                                      </label>
                                    </div>
                                    <p className="mb-0 text-muted col-md-6">
                                      {el.price}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="row align-items-center">
                                <div className="col-md-4">
                                  <div className="form-group row">
                                    <div className="col-md-6">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.FABRIC_CODE_TEXT} -
                                      </label>
                                    </div>
                                    <div className="col-md-6">
                                      {el?.fabricCode ? el?.fabricCode : " -"}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group row">
                                    <div className="col-md-6">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.REMARKS_TEXT} -
                                      </label>
                                    </div>
                                    <p className="mb-0 text-muted col-md-6">
                                      {el.remarks ? el.remarks : "-"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="row align-items-center">
                                <div className="col-md-4">
                                  <div className="form-group row">
                                    <div className="col-md-6">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.COLOR_TEXT} -
                                      </label>
                                    </div>
                                    <div className="col-md-6">
                                      {el?.color ? el?.color : " -"}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row align-items-center">
                                <div className="col-md-4">
                                  <div className="form-group row">
                                    <div className="col-md-6">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.SIZE_TEXT} -
                                      </label>
                                    </div>
                                    <div className="col-md-6">
                                      {el?.size ? el?.size : " -"}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group row">
                                    <div className="col-md-6">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.CUSTOMER_DELIVERY_DATE_TEXT} -
                                      </label>
                                    </div>
                                    <p className="mb-0 text-muted col-md-6">
                                      {el?.custDeliveryDate
                                        ? moment(el?.custDeliveryDate).format(
                                            DATE_FORMAT.STANDARD
                                          )
                                        : "-"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="row align-items-center">
                                <div className="col-md-4">
                                  <div className="form-group row">
                                    <div className="col-md-6">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.QTY_TEXT} -
                                      </label>
                                    </div>
                                    <div className="col-md-6">
                                      <TextBox
                                        placeholder={LABELS.QTY_TEXT}
                                        name={ACTION_LABEL.QTY}
                                        value={el?.qty}
                                        disable={true}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group row">
                                    <div className="col-md-6">
                                      <label
                                        htmlFor=""
                                        className="text-black font-weight-600"
                                      >
                                        {LABELS.SALES_PERSON_TEXT} -
                                      </label>
                                    </div>
                                    <p className="mb-0 text-muted col-md-6">
                                      {el.salesPerson ? el.salesPerson : "-"}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <h6 className="my-3 section-title">
                                {LABELS.SUB_ASSEMBLY_ITEM_TEXT}
                              </h6>

                              <div className="card section-card mb-3">
                                <div className="card-body">
                                  <div className="row">
                                    {el?.measurement?.top?.length > 0 &&
                                      el?.measurement?.top?.map(
                                        (topEl: any) => {
                                          const remarks = topEl?.remarks;
                                          return (
                                            <div className="col-md-4">
                                              <div className="slug-custom-dropdown mb-3 open">
                                                <div className="toggle d-flex align-items-center w-100 justify-content-between">
                                                  <span>{topEl.type}</span>
                                                </div>
                                                <div className="custom-dropdown-menu">
                                                  <div className="item-card">
                                                    <div className="item-body">
                                                      <div className="populate-values">
                                                        {topEl?.data?.map(
                                                          (el: any) => {
                                                            return measurementStandardBlock(
                                                              el
                                                            );
                                                          }
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                {remarks && (
                                                  <div className="row">
                                                    <div className="col-12">
                                                      <div className="form-group">
                                                        <TextArea
                                                          name={
                                                            ACTION_LABEL.REMARKS
                                                          }
                                                          id={
                                                            LABELS.REMARKS_TEXT
                                                          }
                                                          label={
                                                            LABELS.REMARKS_TEXT
                                                          }
                                                          value={remarks}
                                                          maxLength={250}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    {el?.measurement?.bottom?.length > 0 &&
                                      el?.measurement?.bottom?.map(
                                        (bottomEl: any) => {
                                          const remarks = bottomEl?.remarks;
                                          return (
                                            <div className="col-md-4">
                                              <div className="slug-custom-dropdown mb-3 open">
                                                <div className="toggle d-flex align-items-center w-100 justify-content-between">
                                                  <span>{bottomEl.type}</span>
                                                </div>
                                                <div className="custom-dropdown-menu">
                                                  <div className="item-card">
                                                    <div className="item-body">
                                                      <div className="populate-values">
                                                             {bottomEl?.data?.map(
                                                          (el: any) => {
                                                            return measurementStandardBlock(
                                                              el
                                                            );
                                                          }
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                {remarks && (
                                                  <div className="row">
                                                    <div className="col-12">
                                                      <div className="form-group">
                                                        <TextArea
                                                          name={
                                                            ACTION_LABEL.REMARKS
                                                          }
                                                          id={
                                                            LABELS.REMARKS_TEXT
                                                          }
                                                          label={
                                                            LABELS.REMARKS_TEXT
                                                          }
                                                          value={remarks}
                                                          maxLength={250}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}

                                    {el?.measurement?.custom &&
                                      Object.keys(el?.measurement?.custom).map(
                                        (ele: any) => {
                                          return measurementCustomBlock(
                                            ele,
                                            el?.measurement?.custom[ele]
                                          );
                                        }
                                      )}

                                    {el?.measurement?.accessories &&
                                      Object.keys(
                                        el?.measurement?.accessories
                                      ).map((ele: any) => {
                                        return measurementCustomBlock(
                                          ele,
                                          el?.measurement?.accessories[ele]
                                        );
                                      })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })} */}

                      {/* <h6 className="my-3 section-title">
                        {LABELS.TRACKING_INFORMATION_TEXT}
                      </h6>
                      {LABELS.NOT_FOUND_TEXT} */}

                      {orderDetailData?.referenceImages?.filter((img: any) => !img.isPurged)?.length > 0 && (() => {
                        const activeImages = orderDetailData.referenceImages.filter((img: any) => !img.isPurged);
                        const isFullRow = activeImages.length >= 4;
                        return (
                          <>
                            <h6 className="my-3 section-title pt-4">
                              {LABELS.REFERENCE_IMAGES_TEXT}
                            </h6>
                            <div className="card section-card mb-3">
                              <div className="card-body p-3 pt-4">
                                <div
                                  className="d-flex justify-content-start align-items-start gap-2"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "nowrap",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                    gap: isFullRow ? "12px" : "18px",
                                    width: "100%",
                                    pageBreakInside: "avoid",
                                    breakInside: "avoid",
                                  }}
                                >
                                  {activeImages.map((img: any, imgIndex: number) => {
                                    const rawUrl = img.imageUrl || img.thumbnailUrl || "";
                                    const imgUrl = rawUrl.startsWith("http")
                                      ? rawUrl
                                      : `${process.env.REACT_APP_BACKEND_URL || ""}${rawUrl}`;
                                    return (
                                      <div
                                        key={img._id || imgIndex}
                                        className="text-center mb-2"
                                        style={{
                                          pageBreakInside: "avoid",
                                          breakInside: "avoid",
                                          flex: isFullRow ? "1 1 0px" : "0 0 140px",
                                          width: isFullRow ? "auto" : "140px",
                                          maxWidth: isFullRow
                                            ? `${Math.floor(100 / activeImages.length)}%`
                                            : "140px",
                                          minWidth: 0,
                                        }}
                                      >
                                        <img
                                          src={imgUrl}
                                          alt={
                                            img.fileName ||
                                            `Ref ${imgIndex + 1}`
                                          }
                                          style={{
                                            height: "170px",
                                            maxHeight: "170px",
                                            width: isFullRow ? "100%" : "140px",
                                            maxWidth: "100%",
                                            objectFit: "contain",
                                            display: "block",
                                            margin: "0 auto",
                                            borderRadius: "6px",
                                            border: "1px solid #e0e0e0",
                                            backgroundColor: "#fafafa",
                                          }}
                                          onError={(e) => {
                                            const parent = e.currentTarget.parentElement;
                                            if (parent) {
                                              parent.style.display = "none";
                                            }
                                          }}
                                        />
                                        <p
                                          className="mb-0 mt-1"
                                          style={{
                                            fontSize: "11px",
                                            fontWeight: 500,
                                            maxWidth: "100%",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            textAlign: "center",
                                          }}
                                          title={img.fileName || `Image ${imgIndex + 1}`}
                                        >
                                          {img.fileName ||
                                            `Image ${imgIndex + 1}`}
                                        </p>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-5 d-print-none">
              <SimpleButton
                className="btn theme-btn theme-btn-sm me-2"
                onClick={handlePrint}
                text={BUTTON_LABEL.PRINT}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default OrderInvoicePdf;
